import styled from "styled-components";

/**
 * Wrapper do cabeçalho do acordeão
 *
 * Define espaçamento, alinhamento e responsividade para o título e subtítulo.
 * Com `$centered`, título e subtítulo ficam centralizados.
 */
export const AccordionHeaderWrapper = styled.div<{ $centered?: boolean }>`
  margin-bottom: ${({ theme }) => theme.spacing(7)};
  gap: ${({ theme }) => theme.spacing(1)};
  flex-direction: column;
  align-items: ${({ $centered }) => ($centered ? "center" : "flex-start")};
  display: flex;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.xxl}) {
    margin-top: ${({ theme, $centered }) => ($centered ? 0 : theme.spacing(8))};
  }
`;

export const AccordionSectionTitle = styled.h2<{ $centered?: boolean }>`
  margin: 0;
  color: ${({ theme }) => theme.colors.mediumBlue};
  font-size: 2rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.2;
  text-align: ${({ $centered }) => ($centered ? "center" : "left")};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 1.55rem;
  }
`;

export const AccordionSectionSubtitle = styled.p<{ $centered?: boolean }>`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1.4;
  text-align: ${({ $centered }) => ($centered ? "center" : "left")};
`;
